import { useSelector } from 'react-redux';
export default function usePresentSelector(selector,comparator){
  if( typeof(selector) !== 'function' ){
    throw Error('You passed a "selector" that was not found as a function.');
  }
  return useSelector(state => selector(state,comparator));
}
